class FocusHandler{
    static main_instance
    static instances = {}
    static GetInstance(store_key = null){
        let instance;
        if(! store_key){
            instance = this.GetMainInstance()
        }else{
            if(this.instances[store_key]){
                this.InitInstance(store_key)
            }
            instance = this.instances[store_key]
        }
        return instance
    }
    static InitInstance(store_key, ...args){
        this.instances[store_key] = new this(...args)
    }
    static GetMainInstance(){
        if(! this.main_instance){
            this.InitMainInstance()
        }
        return this.main_instance
    }
    static InitMainInstance(...args){
        this.main_instance = new this(...args)
    }
    static Focus(focusable, store_key = null){
        let target_instance;
        if(! store_key){
            target_instance = this.GetInstance()
        }
        target_instance.focus(focusable)
    }
    constructor(){
        this.current_focused = null
    }
    focus(focusable, toggle  = null){
        if(this.current_focused && this.current_focused !== focusable){
            try{
                this.current_focused.unfocus()
            }catch(e){
                console.log(e)
            }
        }
        this.current_focused = focusable
    }
}

export {
    FocusHandler
}



// class FocusHandler{
//     static instance
//     static getInstance(...args){
//         if(! this.instance){
//             this.initInstance(...args)
//         }
//         return this.instance
//     }
//     static initInstance(...args){
//         this.instance = new this(...args)
//     }
//     static Focus(focusable){
//         this.getInstance().focus(focusable)
//     }
//     constructor(){
//         this.current_focused = null
//     }
//     focus(focusable, toggle  = null){
//         console.log(focusable)
//         if(this.current_focused && this.current_focused !== focusable){
//             try{
//                 this.current_focused.unfocus()
//             }catch(e){
//                 console.log(e)
//             }
//         }
//         this.current_focused = focusable
//     }
// }

// export {
//     FocusHandler
// }
